export enum SignalRStatusEnum {
  Success = "success",
  Error = "error",
  Neutral = "neutral",
}

export enum SignalRTypeEnum {
  Report = "report",
  Import = "import",
  Export = "export",
}

export interface SignalRMessage {
  id: string;
  type: SignalRTypeEnum;
  status: SignalRStatusEnum;
  reportUrl?: string;
  exportUrl?: string;
  importId?: string;
  machineName?: string | null;
  timestamp: Date;
}
